import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import NoweZgloszenieMain from "./modules/noweZgloszenie/NoweZgloszenieMain";
import Login from "./modules/adminPanel/login/LoginMain";
import 'bootstrap/dist/css/bootstrap.min.css';
import NoweZgloszenieForm from "./modules/noweZgloszenie/NoweZgloszenieForm";
import Zgloszenia from "./modules/adminPanel/panel/Zgloszenia";
import Ustawienia from "./modules/adminPanel/panel/Ustawienia";
import PanelGlowny from "./modules/adminPanel/panel/PanelGlowny";
import {ConfigProvider} from "antd";
import plPL from 'antd/lib/locale/pl_PL';
import dayjs from "dayjs";
import Zgloszenie from "./modules/adminPanel/panel/Zgloszenie";
import MojeZgloszenieMain from "./modules/mojeZgloszenie/MojeZgloszenieMain";
import {getToken, isLogged, isSuperAdmin, wyloguj} from "./GlobalServices";
import axios from "axios";
import Uzytkownicy from "./modules/adminPanel/panel/Uzytkownicy";
import BrakUprawnien from "./modules/adminPanel/panel/BrakUprawnien";
require('dayjs/locale/pl');

dayjs().locale('pl');

if (isLogged()) {
    if (getToken())
        // if (getToken().indexOf("Bearer") > -1) {
        if (getToken()) {
            axios.defaults.headers.common.Authorization = getToken();
        } else {
            axios.defaults.headers.common.Authorization = "";
            wyloguj();
        }
}

function App() {
  return (
      <Router>
          <ConfigProvider locale={plPL}>
            <Routes>
              <Route path={"/"} Component={NoweZgloszenieMain} />
              <Route path={"/noweZgloszenie"} Component={NoweZgloszenieForm} />
              <Route path={"/mojeZgloszenie"} Component={MojeZgloszenieMain} />
              <Route path={"/login"} Component={isLogged() ? PanelGlowny : Login} />
              <Route path={"/admin"} Component={isLogged() ? PanelGlowny : Login} />
              <Route path={"/admin/zgloszenia"} Component={isLogged() ? Zgloszenia : Login} />
              <Route path={"/admin/zgloszenia/:idZgl"} Component={isLogged() ? Zgloszenie : Login} />
              <Route path={"/admin/uzytkownicy"} Component={isLogged() ? (isSuperAdmin() ? Uzytkownicy : BrakUprawnien) : Login} />
              <Route path={"/admin/ustawienia"} Component={isLogged() ? Ustawienia : Login} />
            </Routes>
          </ConfigProvider>
      </Router>
  );
}

export default App;
